import React, { lazy, Suspense } from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Drawer from "./components/Layout/Drawer/Drawer";

import MerchantRoute from "./config/MerchantRoute";
import AdminRoute from "./config/AdminRoute";
import SadminRoute from "./config/SadminRoute";
import MixRoute from "./config/MixRoute";

// alert
import Alert from "./components/Layout/Alert/Alert";
import LoginScreen from "./screens/LoginScreen";
// import UnApprovedScreen from "./screens/Admin/UnApprovedScreen";

import Loader from "./components/Layout/Loader";
import TestScreen from "./screens/TestScreen";
import PogiConversationScreen from "./screens/Admin/PogiConversationScreen.js";

// import OrdersAllAdminScreen from "./screens/Admin/OrdersAllAdminScreen";

// screens

// Admin Screens
const AdminDashboard = lazy(() => import("./screens/Admin/AdminDashboard"));
const SuperDashboard = lazy(() => import("./screens/Sadmin/SuperDashboard"));

const UnauthorizedScreen = lazy(() => import("./screens/UnauthorizedScreen"));
const Reset = lazy(() => import("./components/Others/Login/Reset"));

const MailsScreen = lazy(() => import("./screens/Admin/MailsScreen"));
const EmailTesterScreen = lazy(() => import("./screens/Admin/EmailTesterScreen"));
const CustomerListScreen = lazy(() => import("./screens/Admin/CustomerListScreen"));
const CustomerScreen = lazy(() => import("./screens/Admin/CustomerScreen"));
const ChatScreen = lazy(() => import("./screens/Admin/ChatScreen"));
const MerchantListScreen = lazy(() => import("./screens/Admin/MerchantListScreen"));
const MerchantCreateScreen = lazy(() => import("./screens/Admin/MerchantCreateScreen"));
const MerchantViewScreen = lazy(() => import("./screens/Admin/MerchantViewScreen"));
const MerchantUpdateScreen = lazy(() => import("./screens/Admin/MerchantUpdateScreen"));

const CollectionCreateScreen = lazy(() => import("./screens/Admin/CollectionCreateScreen"));
const CollectionListScreen = lazy(() => import("./screens/Admin/CollectionListScreen"));
const CollectionViewScreen = lazy(() => import("./screens/Admin/CollectionViewScreen"));
const CollectionUpdateScreen = lazy(() => import("./screens/Admin/CollectionUpdateScreen"));
const TagScreen = lazy(() => import("./screens/Admin/TagScreen"));
const TagCreateScreen = lazy(() => import("./screens/Admin/TagCreateScreen"));
const TagUpdateScreen = lazy(() => import("./screens/Admin/TagUpdateScreen"));
const TagAddScreen = lazy(() => import("./screens/Admin/TagAddScreen"));
// const TagTableScreen = lazy(() => import("./screens/Admin/TagTableScreen"));
const AllOrdersScreen = lazy(() => import("./screens/Admin/AllOrdersScreen"));
const OrderProductsReadScreen = lazy(() => import("./screens/Admin/OrderProductsReadScreen"));
const PageScreen = lazy(() => import("./screens/Admin/PageScreen"));
const PageUpdateScreen = lazy(() => import("./screens/Admin/PageUpdateScreen"));
const PageCreateScreen = lazy(() => import("./screens/Admin/PageCreateScreen"));
const AppPagesScreen = lazy(() => import("./screens/Admin/AppPagesScreen"));
const AppPageEditScreen = lazy(() => import("./screens/Admin/AppPageEditScreen"));
const SupportCasesScreen = lazy(() => import("./screens/Admin/SupportCasesScreen"));
// TicketsScreen removed
const TicketsChatScreen = lazy(() => import("./screens/Admin/TicketsChatScreen"));
const CategoryScreen = lazy(() => import("./screens/Admin/CategoryScreen.js"));
const AllReviewsScreen = lazy(() => import("./screens/Admin/AllReviewsScreen.js"));
const ReviewUpdateScreen = lazy(() => import("./screens/Admin/ReviewUpdateScreen.js"));
const EnquiryScreen = lazy(() => import("./screens/Admin/EnquiryScreen"));
const MProductCustomerList = lazy(() => import("./screens/Admin/MProductCustomerList"));

// const CouponsScreen = lazy(() => import("./screens/Admin/CouponsScreen"));
const CouponCreateScreen = lazy(() => import("./screens/Admin/CouponCreateScreen"));
const CouponListScreen = lazy(() => import("./screens/Admin/CouponListScreen"));
const CouponUpdateScreen = lazy(() => import("./screens/Admin/CouponUpdateScreen"));

const OrdersAdminScreen = lazy(() => import("./screens/Admin/OrdersAdminScreen"));
const BrandsAddScreen = lazy(() => import("./screens/Admin/BrandsAddScreen"));
const InvoicesScreen = lazy(() => import("./screens/Admin/InvoicesScreen"));
const MerchantBrandAddScreen = lazy(() => import("./screens/Admin/MerchantBrandAddScreen"));
const MerchantBrandListScreen = lazy(() => import("./screens/Admin/MerchantBrandListScreen"));
const OrderAdminViewScreen = lazy(() => import("./screens/Admin/OrderAdminViewScreen"));
const MProductsScreen = lazy(() => import("./screens/Admin/MProductsScreen"));
const BrandsListScreen = lazy(() => import("./screens/Admin/BrandsListScreen"));
const BrandsUpdateScreen = lazy(() => import("./screens/Admin/BrandsUpdateScreen"));
const PayoutsScreen = lazy(() => import("./screens/Admin/PayoutScreen"));
const PayoutUpdateScreen = lazy(() => import("./screens/Admin/PayoutUpdateScreen"));
// CustomerSupportScreen removed
// CustomerSupportPanelScreen removed
const SeoExportsScreen = lazy(() => import("./screens/Admin/SeoExportsScreen"));
// TicketCreateScreen removed
const BlogEditScreen = lazy(() => import("./screens/Admin/BlogEditScreen"));
const BlogListScreen = lazy(() => import("./screens/Admin/BlogListScreen"));
const BlogCategoryScreen = lazy(() => import("./screens/Admin/BlogCategoryScreen"));
const BlogCommentsScreen = lazy(() => import("./screens/Admin/BlogCommentsScreen"));

const SettingsScreenAdmin = lazy(() => import("./screens/Admin/SettingsScreen"));

const DataExportScreen = lazy(() => import("./screens/Admin/DataExportScreen"));
const PushNotificationsScreen = lazy(() => import("./screens/Admin/PushNotificationsScreen"));
const AppPogiInsightsScreen = lazy(() => import("./screens/Admin/AppPogiInsightsScreen"));
const AppPogiV2ConversationScreen = lazy(() =>
  import("./screens/Admin/AppPogiV2ConversationScreen"),
);
const PogiPointsProgramScreen = lazy(() => import("./screens/Admin/PogiPointsProgramScreen"));

// Merchant Screens
const MerchantDashboard = lazy(() => import("./screens/Merchant/MerchantDashboard"));
const FaqScreen = lazy(() => import("./screens/Merchant/FaqScreen"));
const InvoiceScreen = lazy(() => import("./screens/InvoiceScreen"));
const OrderReadScreen = lazy(() => import("./screens/Merchant/OrderReadScreen"));
const OrdersScreen = lazy(() => import("./screens/Merchant/OrdersScreen"));
const ProductCreateScreen = lazy(() => import("./screens/Merchant/ProductCreateScreen"));
const ProductsScreen = lazy(() => import("./screens/Merchant/ProductsScreen"));
const ProductUpdateScreen = lazy(() => import("./screens/Merchant/ProductUpdateScreen"));
const ProfileScreen = lazy(() => import("./screens/Merchant/ProfileScreen"));
const TodoScreen = lazy(() => import("./screens/Merchant/TodoScreen"));
const TicketScreen = lazy(() => import("./screens/Merchant/TicketsScreen"));
const PayoutScreen = lazy(() => import("./screens/Merchant/PayoutScreen"));
const PayoutViewScreen = lazy(() => import("./screens/Merchant/PayoutViewScreen"));
const SettingsScreen = lazy(() => import("./screens/Merchant/SettingsScreen"));

// SUPER ADMIN Screens
const SuperTodoScreen = lazy(() => import("./screens/Sadmin/SuperTodo"));
const SuperMProductsScreen = lazy(() => import("./screens/Sadmin/SuperMProductsScreen"));
const SuperMerchantListScreen = lazy(() => import("./screens/Sadmin/SuperMerchantListScreen"));
const SuperMerchantViewScreen = lazy(() => import("./screens/Sadmin/SuperMerchantViewScreen"));
const SuperProductUpdateScreen = lazy(() => import("./screens/Sadmin/SuperProductUpdateScreen"));
const SuperOrdersAdminScreen = lazy(() => import("./screens/Sadmin/SuperOrdersAdminScreen"));
const PermissionListScreen = lazy(() => import("./screens/Sadmin/PermissionListScreen"));
const PermissionEditScreen = lazy(() => import("./screens/Sadmin/PermissionEditScreen"));
const SuperAdminAdd = lazy(() => import("./screens/Sadmin/SuperAdminAdd"));
const SuperLogs = lazy(() => import("./screens/Sadmin/SuperLogs"));

function App() {
  return (
    <Router>
      <Drawer>
        <Alert />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route element={<MixRoute />}>
              <Route exact path="/edit/:id" element={<ProductUpdateScreen />} />
              <Route exact path="/invoice/:oid" element={<InvoiceScreen />} />
              {/* /tickets/chat/:tid removed */}
            </Route>

            <Route element={<MerchantRoute />}>
              <Route exact path="/" element={<MerchantDashboard />} />
              <Route exact path="/products" element={<ProductsScreen />} />
              <Route exact path="/create" element={<ProductCreateScreen />} />
              {/* /ticket removed */}
              <Route exact path="/orders" element={<OrdersScreen />} />
              <Route exact path="/order/:id" element={<OrderReadScreen />} />
              <Route exact path="/faq" element={<FaqScreen />} />
              <Route exact path="/profile" element={<ProfileScreen />} />
              <Route exact path="/todo" element={<TodoScreen />} />
              <Route exact path="/payout" element={<PayoutScreen />} />
              <Route exact path="/payout/view/:mid" element={<PayoutViewScreen />} />
              <Route exact path="/merchant/settings" element={<SettingsScreen />} />
            </Route>

            {/* ADMIN */}
            <Route element={<AdminRoute />}>
              <Route exact path="/admin" element={<AdminDashboard />} />
              <Route exact path="/customerlist" element={<CustomerListScreen />} />
              <Route exact path="/mails" element={<MailsScreen />} />
              <Route exact path="/email-tester" element={<EmailTesterScreen />} />
              <Route exact path="/customer/:custid" element={<CustomerScreen />} />
              <Route exact path="/chat" element={<ChatScreen />} />
              <Route exact path="/createmerchant" element={<MerchantCreateScreen />} />
              <Route exact path="/merchant/list" element={<MerchantListScreen />} />
              <Route exact path="/merchant/view/:id" element={<MerchantViewScreen />} />
              <Route exact path="/merchant/update/:mid" element={<MerchantUpdateScreen />} />
              <Route exact path="/merchant/products" element={<MProductsScreen />} />
              <Route exact path="/invoices/list" element={<InvoicesScreen />} />
              <Route exact path="/AllOrders/list" element={<AllOrdersScreen />} />
              <Route exact path="/AllOrders/list/:orderid" element={<OrderProductsReadScreen />} />
              <Route exact path="/collection/list" element={<CollectionListScreen />} />
              <Route exact path="/collection/create" element={<CollectionCreateScreen />} />
              <Route exact path="/collection/view/:cid" element={<CollectionViewScreen />} />
              <Route exact path="/collection/update/:cid" element={<CollectionUpdateScreen />} />
              <Route exact path="/tags" element={<TagScreen />} />
              <Route exact path="/create/tag" element={<TagCreateScreen />} />
              <Route exact path="/update/tag/:id" element={<TagUpdateScreen />} />
              <Route exact path="/add/tag/:name/:id" element={<TagAddScreen />} />
              {/* <Route exact path="/tagtable" element={<TagTableScreen />} /> */}
              {/* /tickets removed */}
              <Route exact path="/reviews" element={<AllReviewsScreen />} />
              <Route exact path="/review/update/:rid" element={<ReviewUpdateScreen />} />
              <Route exact path="/category" element={<CategoryScreen />} />
              <Route exact path="/coupon/list" element={<CouponListScreen />} />
              <Route exact path="/coupon/create" element={<CouponCreateScreen />} />
              <Route exact path="/coupon/update/:cid" element={<CouponUpdateScreen />} />
              <Route exact path="/payouts" element={<PayoutsScreen />} />
              <Route exact path="/payouts/update/:id" element={<PayoutUpdateScreen />} />
              {/* /customer-support removed */}
              <Route exact path="/support-cases" element={<SupportCasesScreen />} />
              <Route exact path="/enquiry" element={<EnquiryScreen />} />
              <Route exact path="/exports" element={<SeoExportsScreen />} />
              <Route exact path="/admin/orders/:mname/:mid" element={<OrdersAdminScreen />} />
              <Route exact path="/admin/order/:oid" element={<OrderAdminViewScreen />} />
              <Route exact path="/brands" element={<BrandsListScreen />} />
              <Route exact path="/brands/add" element={<BrandsAddScreen />} />
              <Route exact path="/brands/update/:bid" element={<BrandsUpdateScreen />} />
              <Route exact path="/merchant/addbrands/:mid" element={<MerchantBrandAddScreen />} />
              <Route exact path="/merchant/listbrands/:mid" element={<MerchantBrandListScreen />} />
              <Route exact path="/admin/settings" element={<SettingsScreenAdmin />} />
              <Route exact path="/pages" element={<PageScreen />} />
              <Route exact path="/page/create/:type" element={<PageCreateScreen />} />
              <Route exact path="/pageview/:slug" element={<PageUpdateScreen />} />
              <Route exact path="/app-pages" element={<AppPagesScreen />} />
              <Route exact path="/app-page/edit/:id" element={<AppPageEditScreen />} />
              {/* /ticket/create removed */}
              <Route exact path="/blog/postedit/:bid" element={<BlogEditScreen />} />
              <Route exact path="/blog" element={<BlogListScreen />} />
              <Route exact path="/blog/category" element={<BlogCategoryScreen />} />
              <Route exact path="/blog/comments" element={<BlogCommentsScreen />} />
              <Route exact path="/data-export" element={<DataExportScreen />} />
              <Route exact path="/pogi-conversation" element={<PogiConversationScreen />} />
              <Route exact path="/app-pogi-insights" element={<AppPogiInsightsScreen />} />
              <Route
                exact
                path="/app-pogi-v2-conversation"
                element={<AppPogiV2ConversationScreen />}
              />
              <Route exact path="/pogi-points" element={<PogiPointsProgramScreen />} />
              <Route exact path="/push-notifications" element={<PushNotificationsScreen />} />
              <Route
                exact
                path="/merchant/product/customer/:id"
                element={<MProductCustomerList />}
              />
            </Route>

            {/* SUPER ADMIN */}
            <Route element={<SadminRoute />}>
              <Route exact path="/super/todo" element={<SuperTodoScreen />} />
              <Route exact path="/dashboard" element={<SuperDashboard />} />
              <Route exact path="/super/merchant/products" element={<SuperMProductsScreen />} />
              <Route exact path="/super/merchants" element={<SuperMerchantListScreen />} />
              <Route exact path="/super/merchant/view/:id" element={<SuperMerchantViewScreen />} />
              <Route exact path="/super/edit/:id" element={<SuperProductUpdateScreen />} />
              <Route exact path="/super/orders/:mname/:mid" element={<SuperOrdersAdminScreen />} />
              <Route exact path="/super/admins" element={<PermissionListScreen />} />
              <Route exact path="/super/admin/permission/:pid" element={<PermissionEditScreen />} />
              <Route exact path="/super/admin/create" element={<SuperAdminAdd />} />
              <Route exact path="/super/logs" element={<SuperLogs />} />
            </Route>

            {/* <Route path="/login" element={<LoginScreen/>} /> */}
            {/* Unauthorized */}
            <Route exact path="/login" element={<LoginScreen />} />
            <Route exact path="/test" element={<TestScreen />} />
            <Route exact path="/reset/:token" element={<Reset />} />
            <Route exact path="/unauthorized" element={<UnauthorizedScreen />} />
          </Routes>
        </Suspense>
      </Drawer>
    </Router>
  );
}

export default App;
